import React from 'react';
import styled from 'styled-components';
import ScrollTarget from '../elements/ScrollTarget';
var Box = styled(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      title = _ref.title,
      section = _ref.section;
  var scrollTarget;

  if (section) {
    scrollTarget = /*#__PURE__*/React.createElement(ScrollTarget, {
      name: section.target
    });
  }

  return /*#__PURE__*/React.createElement("div", null, scrollTarget, /*#__PURE__*/React.createElement("div", {
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title), children));
}).withConfig({
  displayName: "Box",
  componentId: "myc4z8-0"
})(["background-image:linear-gradient(to bottom,rgba(255,255,255,0.9),rgba(255,255,255,0) 300px),linear-gradient(rgba(255,255,255,0.4),rgba(255,255,255,0.4)),", ";background-repeat:no-repeat;background-position:bottom center;background-size:cover;font-size:18px;margin-bottom:20px;border-radius:10px;background-color:white;box-shadow:0 0 1px rgba(0,0,0,.35);padding:30px;.title{text-transform:uppercase;font-size:", ";line-height:120%;font-family:\"Montserrat\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;margin-bottom:1rem;}"], function (props) {
  return props.bg ? 'url(' + props.bg + ')' : 'none';
}, function (props) {
  return props.titleSize === 'large' ? '300%' : '150%';
});
export default Box;